import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronRightSquareOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.134 6.554C2.888 7.86 2.8 9.608 2.8 12s.088 4.14.334 5.446c.243 1.289.608 1.97 1.03 2.39.42.422 1.101.787 2.39 1.03.458.086.97.153 1.546.204V2.93c-.576.05-1.088.118-1.546.204-1.289.243-1.97.608-2.39 1.03-.422.42-.787 1.101-1.03 2.39M12 21.2c-.764 0-1.461-.009-2.1-.03V2.83c.639-.021 1.336-.03 2.1-.03 2.393 0 4.14.088 5.446.334 1.289.243 1.97.608 2.39 1.03.422.42.787 1.101 1.03 2.39.246 1.306.334 3.054.334 5.446s-.088 4.14-.334 5.446c-.243 1.289-.608 1.97-1.03 2.39-.42.422-1.101.787-2.39 1.03-1.306.246-3.054.334-5.446.334M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1m2.636 14.636L18.273 12l-3.637-3.636-1.272 1.272L15.727 12l-2.363 2.364z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronRightSquareOutlinedSize24Glyph.displayName = 'ChevronRightSquareOutlinedSize24Glyph';
